// Module
var code = "<div> <router-view></router-view> <div v-if=\"loading\" class=\"top48 alignc\"> <loader :delay=\"200\"></loader> </div> </div> ";
// Exports
export default code;